module.exports = __webpack_public_path__ + "static/img/14.61070ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/14.png
// module id = pUR1
// module chunks = 7